export default __webpack_public_path__ + "static/media/homepage-topbtn.40f60f89.png";